import { Component, AfterViewInit, Inject, ElementRef, Renderer2 } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";




@Component({
  selector: 'app-identity-verification',
  templateUrl: './identity-verification.component.html',
  styleUrls: ['./identity-verification.component.scss']
})
export class IdentityVerificationComponent implements AfterViewInit {

  dialogRef: any;
  url!: string;
  incode: any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public dataParam: any,
    public dialog: MatDialog,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.url = dataParam.url;
  }


  /**
   * After view init
   * @description When the view is initialized, set the iframe attributes
   * @return {*}  {Promise<void>}
   * @memberof IdentityVerificationComponent
   * @author victor.mendez
   */
  async ngAfterViewInit(): Promise<void> {
    const iframe = this.el.nativeElement.querySelector('#content-iframe');
    if (iframe) {
      this.renderer.setAttribute(iframe, 'src', this.url);
      this.renderer.setStyle(iframe, 'width', '100%');
      this.renderer.setStyle(iframe, 'height', 'calc(100vh * 0.7)');
      this.renderer.setAttribute(iframe, 'frameborder', '0');
      this.renderer.setAttribute(iframe, 'allow', 'geolocation; microphone; camera; gyroscope;');
      iframe.allowUserMedia = true;
    }
  }


}
